var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationsDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 56",
    style: {
      enableBackground: "new 0 0 50 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B4CCDD;}\r\n\t.st1{fill:none;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.7,18.9c-3.1-3.1-8.2-3.1-11.4,0c-2.8,2.8-3.1,8.2-0.7,11.4l6.4,9.3l6.4-9.3C33.8,27,33.5,21.7,30.7,18.9z  M25,29.1c-2.4,0-4.4-2-4.4-4.4s2-4.4,4.4-4.4s4.4,2,4.4,4.4S27.4,29.1,25,29.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25,20.3c-2.4,0-4.4,2-4.4,4.4s2,4.4,4.4,4.4s4.4-2,4.4-4.4S27.4,20.3,25,20.3z M25,26.9 c-1.2,0-2.2-1-2.2-2.2c0-1.2,1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2C27.2,25.9,26.2,26.9,25,26.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 25,
    cy: 24.7,
    r: 2.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationsDefault);
export default __webpack_public_path__ + "static/media/locations-default.3b0cb5345f898c1e96a731795b8a028e.svg";
export { ForwardRef as ReactComponent };